import React, { useRef } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import * as f from '../logic';
import { RE_YELLOW, RE_GREEN, RE_RED } from '../const';

const Scoreboard = props => {
  const { stats, size, msecs } = props;
  const moreStats = f.getMoreStats(stats, size, msecs);
  let { plays, aveScore, bestScore, grade, score } = moreStats;
  const l = useRef({});
  const { prevStats } = l.current;

  if (msecs % 1000 === 0 || props.over) {
    l.current.prevStats = moreStats;
  } else if (prevStats) {
    plays = prevStats.plays;
    aveScore = prevStats.aveScore;
    bestScore = prevStats.bestScore;
    grade = prevStats.grade;
    score = prevStats.score;
  }

  return (
    <div className="tt-scoreboard" style={{ textShadow: 'initial', color: 'black' }}>
      <span style={{ gridArea: '1/1', color: RE_YELLOW, fontWeight: 'bold' }}>{plays || 0}</span>
      <span style={{ gridArea: '2/1', marginTop: '-1px' }}>plays</span>
      <span style={{ gridArea: '1/2', color: RE_GREEN, fontWeight: 'bold' }}>{aveScore || 0}</span>
      <span style={{ gridArea: '2/2', marginTop: '-1px' }}>ave. score</span>
      <span style={{ gridArea: '1/3', color: RE_GREEN, fontWeight: 'bold' }}>{bestScore || 0}</span>
      <span style={{ gridArea: '2/3', marginTop: '-1px' }}>best score</span>
      <span className="tt-quartz" style={{ gridArea: '3/1', color: RE_YELLOW }}>
        {grade}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/1' }}>
        grade
      </span>
      <span className="tt-quartz" style={{ gridArea: '3/2', color: RE_RED }}>
        {size + 1}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/2' }}>
        stack size
      </span>
      <span className="tt-quartz" style={{ gridArea: '3/3', color: RE_GREEN }}>
        {score}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/3' }}>
        score
      </span>
    </div>
  );
};

function mapStateToProps({ re, common }) {
  return { ...re, ...common };
}

export default connect(
  mapStateToProps,
  {}
)(Scoreboard);
